import React, { useState,useEffect } from 'react';
import {Avatar,TextField, Button,Grid,Paper,Typography,Container} from '@material-ui/core';
import LockOutLinedIcon from '@material-ui/icons/LockOutlined';
import Input from './Input';
import {GoogleLogin} from 'react-google-login';
import Icon from './icon';
import {useDispatch} from 'react-redux';
import { useNavigate } from "react-router-dom";
import {signin,signup} from '../../actions/auth';

import useStyles from './styles';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';


const initialState = {firstName:'',lastName:'',email:'',password:'',confirmPassword:''};


function AuthLogic() {
    
    const classes= useStyles()
    const [showPassword,setShowPassword]= useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [formData1, setFormData]= useState(initialState);

    const [isSignup,setIsSignUp]= useState(false)
    function handleShowPassword(){
        setShowPassword((prevShowPassword)=>!prevShowPassword)
    }

    function handleSubmit(event){
        event.preventDefault()
        
        if(isSignup){
            dispatch(signup(formData1,navigate));
        }else{
            dispatch(signin(formData1,navigate));
        }
        

    }
    function handleChange(e){
        setFormData({...formData1,[e.target.name]: e.target.value})
    
    };

    function switchMode(){
        setIsSignUp((prevIsSignUp)=>!prevIsSignUp);
        setShowPassword(false)
    };
    const googleSuccess= async (res)=>{
           const result = res?.profileObj;
           const token = res?.tokenId;

           try {
               dispatch({type:"AUTH",data:{result,token}});
               navigate('/');
           } catch (error) {
               console.log(error)
           }
    };

    const googleFailure =(error)=>{
        console.log(error);
        console.log("Google sign in was unsuccessfull. Try again later");
    };

    useEffect(() => {
        window.scroll(0,0)
        
      }, []);

    return (
        <Container className={classes.wrapper} component='main' maxWidth='xs' >
            <Paper className={classes.paper} elevation={3} >
                <Avatar  className={classes.avatar}>
                    <LockOutLinedIcon />
                </Avatar>
                <Typography variant='h5'>{isSignup? 'Sign Up': 'Sign In'} </Typography>
                <form className={classes.form} onSubmit={handleSubmit} >
                    <Grid container spacing={2} >
                        {
                            isSignup && (
                                <>
                                        <Input name='firstName' label='First Name'  handleChange={handleChange} autoFocus half />
                                        <Input name='lastName' label='Last Name'  handleChange={handleChange}  half />
                                       
                                </>
                            )}
                               
                                <Input name='email' label='Email Address' handleChange={handleChange} type='email' />
                                <Input name='password' label='Password' handleChange={handleChange} type={showPassword?'text':'password'} handleShowPassword={handleShowPassword} />
                                {
                                    isSignup && <Input name='confirmPassword' label='Repeat Password' handleChange={handleChange} type='password' />
                                }
                            
                        
                    </Grid>
                    
                    <Button type='submit' fullWidth variant='contained'   className={classes.submit}  >
                        {isSignup? 'Sign Up': 'Sign In'}
                    </Button>
                    {/* <GoogleLogin
                        
                        clientId='816158279708-5nkfqghnkatupgf4k7totroiaegi2in3.apps.googleusercontent.com'
                        render={(renderProps)=>(
                            <Button className={classes.googleButton} color='primary' fullWidth onClick={renderProps.onClick} disabled={renderProps.disabled} startIcon={<Icon />} variant='contained' > Google Sign In</Button>
                        )}
                        onSuccess={googleSuccess}
                        onFailure={googleFailure}
                        cookiePolicy="single_host_origin"
                        
                    /> */}
                    {/* <Grid container justifyContent='flex-end'>
                            <Grid item>
                                <Button onClick={switchMode}>
                                    {isSignup?'Already have an account? Sign in':"Don't have an account? Sign up"}
                                </Button>
                            </Grid>
                    </Grid> */}
                </form>
            </Paper>
        </Container>
    )
}

export default AuthLogic
